import { PermissionsEnum } from "@/auth/interfaces";
import { EstadoPreventaEnum, EstadosPreagendamientoEnumChoice, ModulosEnumChoice, newMotivoPreagendamientoSchema, TABLE_CONSTANTS, texto } from "@/shared";
import { useFetchMotivosRechazo, useFetchPreagendamientos, useUpdatePreagendamiento } from "@/shared/actions/erp";
import { CustomAutocomplete, CustomTextArea, GeneralTable } from "@/shared/components/ui";
import { FormMotivoRechazoPreagendamiento, MotivoRechazo, IPreagendamiento } from "@/shared/interfaces";
import { Grid, IconButton, Tooltip } from "@mui/material";
import { useCheckPermissions, useTableColumnsPreagendamientoVentas, useTableFilter, useTableServerSideFiltering } from "@/shared/hooks";
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { useState } from "react";
import { ScrollableDialogProps } from "@/shared/components/ui/Dialogs";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import UpdateIcon from '@mui/icons-material/Update';
import { useUiStore } from "@/store/ui";
// import { useAuthStore } from "@/store/auth";
// import { BitacoraSalaProps } from "@/shared/components/ui/Bitacora/BitacaraSala/BitacoraSala";
interface PreRechazoPreagendamientoVentaProps {
  es_pyme?: boolean
}

const PreRechazoPreagendamientoVenta = ({ 
  es_pyme = false,
}: PreRechazoPreagendamientoVentaProps) => {

  useCheckPermissions(PermissionsEnum.api_view_preagendamiento);

  ///* State
  const [modalCancelar, setModalCancelar] = useState(false);
  // const [bitacoraProps, setBitacoraProps] = useState<BitacoraSalaProps | null>(null)
  // const [modalBitactora, setModalBitactora] = useState(false);

  // const username = useAuthStore(s => s.user)?.username;

  ///* Hook
  const { columnaPreagendamientoPreRechazo } = useTableColumnsPreagendamientoVentas({});


  const {
    pagination,
    searchTerm,
    dateBefore,
    dateAfter,
    setPagination,
    vendedor,
  } = useTableFilter();

  const { pageIndex, pageSize } = pagination;

  ///* Form
  const formRechazo = useForm<FormMotivoRechazoPreagendamiento>({
    resolver: yupResolver(newMotivoPreagendamientoSchema)
  });

  const {
    reset: resetRechazar,
  } = formRechazo;

  ///* React Query
  const {
    data: motivosRechazoPaging,
    isLoading: isLoadingMotivosRechazo,
    isRefetching: isRefetchingMotivosRechazo,
  } = useFetchMotivosRechazo({
    estado: true,
    modulo: ModulosEnumChoice.PREAGENDAMIENTO,
    page_size: 100,
  });

  const {
    mutateAsync: mutateAsyncPreagendamiento
  } = useUpdatePreagendamiento<Partial<IPreagendamiento>>({})


  const setConfirmDialog = useUiStore(s => s.setConfirmDialog);
  const setConfirmDialogIsOpen = useUiStore(s => s.setConfirmDialogIsOpen);

  const { filterObject, columnFilters, setColumnFilters } =
    useTableServerSideFiltering();


  const { isLoading, data: agendaRes,
    isRefetching, } = useFetchPreagendamientos(
      {
        enabled: true,
        params: {
          estado_preagendamiento_in: EstadosPreagendamientoEnumChoice.PRERECHAZADO,
          identificacion: searchTerm,
          es_pyme,
          page: pageIndex + 1,
          page_size: pageSize,
          fecha_creacion_after: dateAfter,
          fecha_creacion_before: dateBefore,
          user_create: vendedor,
          ...filterObject,
          filterByState: false
        }
      }
    );

  return (
    <>
      <Grid container spacing={2} >

        <Grid item xs={12}>
          {/* <CustomSearchFilterSupervisorVenta
            onChange={onChangeFilter}
            value={globalFilter}
            text="por Identificación"
            onChangeRangeDate={onChangeRangeDate}
            cleanFilter={cleanFilter}
            setVendedor={setVendedor}
            vendedor={vendedor}

          /> */}
        </Grid>

        <Grid item xs={12}>
          <GeneralTable<IPreagendamiento>
            columns={columnaPreagendamientoPreRechazo}
            data={agendaRes?.data.data || []}
            isLoading={isLoading}
            isRefetching={isRefetching}
            // // search
            enableGlobalFilter={false}
            // onGlobalFilterChange={setGlobalFilter}
            pagination={pagination}
            onPaging={setPagination}
            rowCount={agendaRes?.data?.count}

            ///* filters - server side
            enableManualFiltering={true}
            columnFilters={columnFilters}
            onColumnFiltersChange={setColumnFilters}
            enableSorting={false}

            // crud
            canEdit={false}
            showCustomActionBtnSpace={true}
            enableColumnActions={true}
            enableEditing={true}

            actionsColumnSize={TABLE_CONSTANTS.ACTIONCOLUMN_WIDTH_BIG}
            customActionBtnSpace={(value) => {
              return (
                <Grid container>

                  <Grid item>
                    <Tooltip title={'Reversar'} placement="top">
                      <IconButton
                        onClick={() => {

                          setConfirmDialogIsOpen(true);
                          setConfirmDialog({
                            isOpen: true,
                            title: '¡Confirmar!',
                            subtitle:
                              'Estás a punto de reversar una venta de preagendamiento a PYL. Este cambio es irreversible. ¿Te gustaría continuar?',
                            onClose() {
                              setConfirmDialogIsOpen(false);
                            },
                            async onConfirm() {
                              setConfirmDialogIsOpen(false);
                              await mutateAsyncPreagendamiento({
                                id: value.id_preagendamiento!,
                                data: {
                                  estado_preagendamiento: EstadosPreagendamientoEnumChoice.EN_ESPERA
                                },
                              });
                            },
                            cancelTextBtn: 'Cerrar',
                          });


                        }
                        }
                      >
                        <UpdateIcon />
                      </IconButton>
                    </Tooltip>
                  </Grid>

                  <Grid item>
                    <Tooltip title={texto.cancelado} placement="top">
                      <IconButton
                        onClick={() => {
                          setModalCancelar(true)
                          resetRechazar({
                            id_preagendamiento: value.id_preagendamiento,
                            identificacion: value.prospecto_data.identificacion,
                            razon_social: value.prospecto_data.razon_social,
                            observaciones: value.observaciones
                          })
                        }
                        }
                      >
                        <HighlightOffIcon color="error" />
                      </IconButton>
                    </Tooltip>
                  </Grid>



                </Grid>
              )
            }}

          />
        </Grid>



      </Grid>


      {modalCancelar && (
        <ScrollableDialogProps
          open={modalCancelar}
          title="¡Confirmar!"
          confirmVariantBtn="contained"
          dialogContentText={`Estás a punto de cancelar un preagendamiento del cliente ${formRechazo.getValues().razon_social}
          con la identificación ${formRechazo.getValues().identificacion}. ¿Estás seguro? Este cambio es irreversible.`}
          contentNode={
            <Grid container spacing={3}>

              <CustomAutocomplete<MotivoRechazo>
                label="Motivo de rechazo"
                name="motivo_rechazo"
                // options
                options={motivosRechazoPaging?.data?.data || []}
                valueKey="nombre"
                actualValueKey="codigo"
                defaultValue={formRechazo.getValues().motivo_rechazo || ''}
                isLoadingData={
                  isLoadingMotivosRechazo || isRefetchingMotivosRechazo
                }
                // validation
                control={formRechazo.control}
                error={formRechazo?.formState?.errors.motivo_rechazo}
                helperText={
                  !!formRechazo?.formState?.errors.motivo_rechazo?.message &&
                  'El motivo de rechazo es requerido'
                }
                disableClearable
              />

              <CustomTextArea
                label="Observación"
                name="observacion_cancelacion"
                maxRows={3}
                control={formRechazo.control}
                defaultValue={formRechazo.getValues().observacion_cancelacion ?? ''}
                error={formRechazo.formState.errors.observacion_cancelacion}
                helperText={formRechazo.formState.errors.observacion_cancelacion?.message}
                required={false}
              />

            </Grid>
          }
          onConfirm={formRechazo.handleSubmit(async (form) => {
            const resp = await mutateAsyncPreagendamiento({
              id: form.id_preagendamiento,
              data: {
                estado_preagendamiento: EstadoPreventaEnum.CANCELADO,
                motivo_rechazo: form.motivo_rechazo,
                observaciones: {
                  ...form.observaciones,
                  observacion_cancelacion: form.observacion_cancelacion
                }
              }
            });
            if (resp.code === 200) {
              resetRechazar({});
              setModalCancelar(false);
            }

          })}
          onClose={() => {
            resetRechazar({});
            setModalCancelar(false)
          }}
        />
      )}
    </>
  );

}

export default PreRechazoPreagendamientoVenta;